<header class="topbar">
  <button type="button" class="topbar__icon-btn" (click)="theme.toggleSidebar()" aria-label="Toggle navigation">
    <i class="fa-solid fa-bars" aria-hidden="true"></i>
  </button>

  <div class="topbar__title">
    @if (page().section) {
      <nav aria-label="breadcrumb">
        <ol class="topbar__crumbs">
          <li>{{ page().section }}</li>
          <li aria-current="page">{{ page().title }}</li>
        </ol>
      </nav>
    }
    <h1>{{ page().title }}</h1>
  </div>

  <div class="topbar__actions">
    @if (session.currentUser(); as user) {
      <div ngbDropdown placement="bottom-end" display="dynamic">
        <button type="button" class="topbar__user" ngbDropdownToggle aria-label="Account menu">
          <span class="avatar">{{ session.initials() }}</span>
          <span class="topbar__user-text d-none d-md-flex">
            <strong>{{ user.userName }}</strong>
            <small>{{ user.roleName }}</small>
          </span>
          <i class="fa-solid fa-chevron-down topbar__chevron d-none d-md-inline" aria-hidden="true"></i>
        </button>
        <div ngbDropdownMenu class="topbar__menu">
          <div class="topbar__menu-head">
            <strong>{{ user.userName }}</strong>
            <small>{{ user.email || user.loginId }}</small>
          </div>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem type="button" class="text-danger" (click)="confirmLogout()"><i class="fa-solid fa-right-from-bracket fa-fw"></i> Sign out</button>
        </div>
      </div>
    }
  </div>
</header>
